$(document).ready(function(){

  // testimonial slider
  $('.testimonial-list-slider').slick({
    infinite: false,
    arrows: true,
    dots: false,
    slidesToShow: 2.1,
    slidesToScroll: 1,
    prevArrow: '<div class="pre-btn"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="22" viewBox="0 0 25 22" fill="none"><path d="M4.98127 12.0505L12.3609 19.4301L10.6421 21.1489L0.328125 10.835L1.18752 9.97555L10.6421 0.520973L12.3609 2.23977L4.98127 9.6194L24.6392 9.6194V12.0505L4.98127 12.0505Z" fill="black"/></svg></div>',
    nextArrow: '<div class="next-btn"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="22" viewBox="0 0 25 22" fill="none"><path d="M19.9855 12.0505L12.6059 19.4301L14.3247 21.1489L24.6387 10.835L23.7793 9.97555L14.3247 0.520973L12.6059 2.23977L19.9855 9.6194L0.32759 9.6194V12.0505L19.9855 12.0505Z" fill="black"/></svg></div>',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  
});